













































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FilterForm extends Vue {
  form = {
    name: '',
    title: '',
    major: '',
  };

  articleForm = {
    title: '',
    introduction: '',
    detail: '',
    order: '',
    seq: '',
  };

  // 职称选项表
  @Prop({
    type: Array,
    default: () => ['院长', '副院长', '党委书记', '党委副书记', '常务副院长', '学工负责人'],
  })
  titleList: string[] | undefined;

  // 专业选项表
  @Prop({
    type: Array,
    default: () => [],
  })
  majorList: string[] | undefined;

  @Prop({
    type: String,
    default: 'teacher',
  })
  type: 'teacher' | 'article' | undefined;

  @Prop({
    type: [Boolean, String],
    default: false,
  })
  show: boolean | string | undefined;

  get collapseItems() {
    if (this.show !== undefined && this.show !== false) {
      return ['filterForm'];
    }
    return [];
  }

  changeSort(field, val) {
    if (this.articleForm[field] !== val) {
      this.$set(this.articleForm, field, val);
    } else {
      this.$set(this.articleForm, field, '');
    }
  }

  onCollapse() {
    if (this.collapseItems.includes('filterForm')) {
      this.$emit('toggle', true);
    } else {
      this.$emit('toggle', false);
    }
  }

  onSortBtnClick(key: string, seq: string) {
    const { articleForm } = this;
    if (articleForm.order === key && articleForm.seq === seq) {
      articleForm.order = '';
    } else {
      articleForm.order = key;
      articleForm.seq = seq;
    }
  }

  clear() {
    this.form = {
      name: '',
      title: '',
      major: '',
    };
    this.articleForm = {
      title: '',
      introduction: '',
      detail: '',
      order: '',
      seq: '',
    };
  }

  onSubmit() {
    this.$emit('submit', this.type === 'article' ? this.articleForm : this.form);
  }
}
